// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__32Fpn","label":"Category_label__MoVYc","content":"Category_content__1JPwJ","header":"Category_header__2GTwF","location":"Category_location__1IxVW"};